<template>
  <card col-md-12>
    <h4 slot="header" class="card-title">Manifestação</h4>
      <reload  v-if="reload_hab"></reload>
      <div class="row">
        <div class="col-md-12" v-if="result_detalhes">
            <div class="card" style="margin-top:20px;" >
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                          <p class="p-line">Numero da Manifestação: <span class="badge badge-secondary" style="font-size: 14px;">{{result_detalhes.numero_manifesto}}</span> </p>
                          <p class="p-line">Tipo: <span class="badge badge-secondary" style="font-size: 14px;">{{result_detalhes.tipo_assunto}}</span></p> 
                          <p class="p-line">
                            Secretaria: {{result_detalhes.secretaria}}
                          </p>
                          <p class="p-line">
                            Assunto: {{result_detalhes.assunto}}
                          </p>
                          <p class="p-line">
                            Descrição: {{result_detalhes.conteudo}}
                          </p>
                          <p class="p-line" v-if="result_detalhes.bairro">
                            Bairro: {{result_detalhes.bairro}}
                          </p>
                          <p class="p-line">
                            <i v-if="result_detalhes.rua">{{result_detalhes.rua}},</i> <i v-if="result_detalhes.numero">{{result_detalhes.numero}} -</i>
                            <i v-if="result_detalhes.complemento">{{result_detalhes.complemento}}</i>
                          </p>
                          
                          <p class="p-line">
                            {{result_detalhes.abertura}}
                          </p>
                        </div>
                    </div>
                    
                </div>  
            </div> 
        </div>
        <div class="col-md-12" v-if="ativar == 0" style="transition-duration: 2.2s, 0.2s;">
            <div class="row">
                <div class="col-md-12" style="padding-left: 16px;padding-top: 0;margin-top: -18px;">
                    <button class="btn btn-default" @click="comentarios()">Comentar</button>
                    <button class="btn btn-danger" @click="retornarform()"  style="margin-left: 8px;">Voltar</button>
                </div>
            </div>
        </div> 
        
        <div class="col-md-12" v-if="ativar == 1" style="transition-duration: 2.2s, 0.2s;">
            <div class="row">
                <div class="col-md-12" style="padding-left: 16px;padding-top: 0;">
                    <div class="form-group">
                      <label for="descricao">Comentário:</label>
                      <textarea class="form-control" rows="5" id="descricao" name="descricao" v-model="comenta" ></textarea>
                    </div>
                    <button class="btn btn-primary" @click="salvarComentario()" v-if="desab_coment == 0">Adicionar Comentário</button>
                    <button class="btn btn-primary" v-else disabled >Adicionar Comentário</button>
                    <button class="btn btn-danger" @click="cancelComentario()" style="margin-left: 8px;">Cancelar</button>
                </div>
            </div>
        </div>
       
      </div>  
      <div class="clearfix"></div>
      <div class="timeline" >
        <div v-for="c in exibirconversa" :key="c.id">
        <div class="containerline_sistema right" v-if="c.conversa_sistema !=null">
          <div class="content" >
            <div v-if="c.conversa_sistema !=null">
                <h3>Administrador</h3>
                <p v-html="c.conversa_sistema"></p>
            </div>
          </div>
        </div>
        <div class="containerline right" v-else>
          <div class="content" >
            <div v-if="c.conversa_cidadao !=null">
                <h3 v-html="c.cidadao"></h3>
                <p v-html="c.conversa_cidadao"></p>
            </div>
          </div>
        </div>
        </div>
      </div>
      
  </card>
</template>
<script>
  //import { required, minLength, maxLength, between} from 'vuelidate/lib/validators'
  import Reload from 'src/components/Reload-v1.vue'
  import Card from 'src/components/Cards/Card.vue'
  import axios from 'axios';
  import store_cidadao from "src/storeCidadao.js"
  import 'src/controller/cidadao/cidadaoController.js'
  
  //import 'src/controller/sistema/manifestacaoController.js'

  export default {
    components: {
      Card,
      Reload
    },
    props: {
      result_detalhes: {
          require: true
      }
    },
    data () {
      return {
        reload_hab:false,
        ativar: 0,
        desab_coment:0,
        comenta:null,
        exibirconversa:[],
        resposta_conv:null
      }
    },
    methods: {
      comentarios(){
        this.ativar=1; 
        //console.log(this.ativar);
      },
      async salvarComentario(){
         try {
            if(this.comenta == null || this.comenta == ""){
              return false
            }

            this.result_detalhes.cidadao_login = store_cidadao.id_cidadao;

            let usuarioSistema = 0;
            
            if(this.result_detalhes.cidadao_login == null){
              this.result_detalhes.cidadao_login = 0 ;
            }
            this.desab_coment =1;
            this.reload_hab = true;
            let data = await this.$conversaManifestoCidadao(this.result_detalhes.uuid,this.result_detalhes.cidadao_login,usuarioSistema,this.result_detalhes.assunto,this.result_detalhes.tipo_assunto,this.comenta);
            
            this.desab_coment = 0;
            this.reload_hab = false;
            this.ativar=0;
            this.comenta = null;
            this.exibirconversa=[];
            this.listarEssaConversa(this.result_detalhes.uuid);

            this.$alert("Sua mensagem foi enviada!");
         } catch (error) {
           
         }
      },
      cancelComentario(){
         this.ativar=0;
         this.comenta = null;
      },
      retornarform(){
         this.$router.push('/painelcidadao/minhasmanifestacoes');
      },
      async listarEssaConversa(uuid){
        try {
          let data = await this.$ListarConversaIdC(uuid);
          this.resposta_conv = data.data;

          let me = await this.$meuLoginCidadao();
          let resposta = me;
          this.result_detalhes.cidadao_login = resposta.id_cidadao;
          let userSistema = 0;
          let userCidadao = resposta.name;
          

          this.resposta_conv.forEach(array => {
              this.filtro(array,userCidadao);
          });
        }catch (e) {
           
        }  
      },
      async filtro(array,userCidadao) {
         try {
           let usuario_sistema;
           let usuario_cidadao;

            let conversa = {
              id: array.id,
              cidadao: userCidadao,
              usuario_sistema: usuario_sistema,
              conversa_sistema: array.conversa_sistema,
              conversa_cidadao: array.conversa_cidadao,
            };

          this.exibirconversa.push(conversa);

         }catch(e){
            
         }
      }   
    },
    beforeMount() {
      if(this.result_detalhes == null){
        this.$router.push('/painelcidadao/minhasmanifestacoes');
      }else{
        this.listarEssaConversa(this.result_detalhes.uuid);
      }  
   }
  }
  

</script>
<style>
   .p-line{
      line-height: 1.2 !important;
   }


/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  margin: 0 auto;
  margin-top:20px;
  background-color: #e4e3e1;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 2%;
  margin-left: -3px;
}

/* Container around content */
.containerline {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 98%;
}
.containerline_sistema {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 98%;
}

/* The circles on the timeline */
.containerline::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -17px;
  background-color: white;
  border: 4px solid #FF9F55;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}
.containerline_sistema::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -17px;
  background-color: white;
  border: 4px solid #4061a8;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 2%;
}

/* Add arrows to the left container (pointing right) */
.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid white;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
  left: -16px;
}

/* The actual content */
.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .timeline::after {
  left: 31px;
  }
  
  /* Full-width containers */
  .containerline {
  width: 100%;
  padding-left: 70px;
  padding-right: 25px;
  }
  .containerline_sistema {
  width: 100%;
  padding-left: 70px;
  padding-right: 25px;
  }
  
  
  /* Make sure that all arrows are pointing leftwards */
  .containerline::before {
  left: 60px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
  }

  .containerline_sistema::before {
  left: 60px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .left::after, .right::after {
  left: 15px;
  }
  
  /* Make all right containers behave like the left ones */
  .right {
  left: 0%;
  }
}
</style>
